module.exports = __webpack_public_path__ + "media/images/dolby_atmos_black-d366c32e928ff2612f2f8effcc92517d.png";